import type { FormField } from '@funkit/connect-core'
import { type KycFieldIssue, stringValue, underageIssue } from './kycFormState'

export function kycFieldValidators(field: FormField, ssnDigits?: 4 | 9) {
  let validate: (input: {
    value: string | undefined
  }) => KycFieldIssue | undefined
  if (field.type === 'DATE') {
    validate = ({ value }) => underageIssue(stringValue(value))
  } else if (ssnDigits !== undefined) {
    validate = ({ value }) =>
      stringValue(value).length === ssnDigits ? undefined : 'PATTERN'
  } else {
    return undefined
  }
  return { onMount: validate, onChange: validate }
}
